import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import styles from "./Guide.module.css";
import { GUIDE_CARDS } from "../../../data/resources";
import ConsultationOverlay from "../../layout/ConsultationOverlay";
import { Animate, Stagger } from "../../animations";

const Guide = () => {
  return (
    <section className={styles.guide}>
      <div className={styles.guideInner}>
        <Animate variant="fadeUp">
          <h4 className={styles.heading}>Keeping You Sorted</h4>
          <h1 className={styles.title} id="heading-large">
            Your Study Abroad Roadmap
          </h1>
        </Animate>
        <Stagger className={styles.cards} variant="fadeUp" stagger={110}>
          {GUIDE_CARDS.map((card) => (
            <div key={card.title} className={`${styles.card} anim-hover-lift`}>
              <h2 className={styles.cardTitle}>{card.title}</h2>
              <NavLink to={card.route}>
                <button className={styles.readMoreButton}>Learn More</button>
              </NavLink>
              <hr className={styles.hr} />
              <p className={styles.cardDescription}>{card.description}</p>
            </div>
          ))}
        </Stagger>
        <Animate variant="fadeUp" delay={80}>
          <GuideBottom />
        </Animate>
      </div>
    </section>
  );
};

export default Guide;

export const GuideBottom = () => {
  const [showOverlay, setShowOverlay] = useState(false);

  return (
    <div className="text-center py-8">
      <h4 className={styles.caseStudiesHeading}>Let us help you study abroad</h4>
      <h1 id="heading-large" className={styles.caseStudiesTitle}>
        Ready to Start Your Journey?
      </h1>
      <p className={styles.caseStudiesDescription}>
        Book a free consultation with our expert counsellors or explore our
        affordable packages to get started today.
      </p>
      <div className="flex flex-col sm:flex-row justify-center items-stretch sm:items-center w-full gap-3 sm:gap-4">
        <button className={styles.heroButton} onClick={() => setShowOverlay(true)}>
          Get Free Consultation
        </button>
        <NavLink to="/pricing">
          <button className={styles.heroButtonSecondary}>View Pricing</button>
        </NavLink>
      </div>
      {showOverlay && <ConsultationOverlay onClose={() => setShowOverlay(false)} />}
    </div>
  );
};
